import { render } from "./WiseFrontLogin.vue?vue&type=template&id=3376067c"
import script from "./WiseFrontLogin.vue?vue&type=script&lang=js"
export * from "./WiseFrontLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__